import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const InfoFilledIcon = ({ className, opacity = 1, color = Color.Red500 }: NewIconProps) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g opacity={opacity}>
      <path
        d="M8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663ZM7.33398 7.33301V11.333H8.66732V7.33301H7.33398ZM8.00065 5.99967C8.36884 5.99967 8.66732 5.7012 8.66732 5.33301C8.66732 4.96482 8.36884 4.66634 8.00065 4.66634C7.63246 4.66634 7.33398 4.96482 7.33398 5.33301C7.33398 5.7012 7.63246 5.99967 8.00065 5.99967Z"
        fill={color}
      />
    </g>
  </svg>
);
